// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "footer-12gFK";
export { _1 as "__esModule", _2 as "footer" }
export default { "__esModule": _1, "footer": _2 }
